__turbopack_context__.v({
  "image": "ImageCard-module-scss-module__JmsVMW__image",
  "imageContainer": "ImageCard-module-scss-module__JmsVMW__imageContainer",
});
